import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';

import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Information from './pages/Information';
import { AuthProvider } from './contexts/AuthContext';
import Admin from './pages/Admin';
import Login from './pages/Login';
import Nis2 from './pages/Nis2';
import TopBanner from './components/TopBanner';
// További oldalak importálása...

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-900 flex flex-col">
          <TopBanner />
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/szolgaltatasok" element={<Services />} />
            <Route path="/kapcsolat" element={<Contact />} />
            <Route path="/adatvedelem" element={<Privacy />} />
            <Route path="/tudnivalok" element={<Information />} />
            <Route path="/nis2" element={<Nis2 />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/login" element={<Login />} />
          </Routes>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
